import ar from './ar.json';
import en from './en.json';

export const messages: any = {
  ar,
  en,
};
